import axios from 'axios'
import { getSession } from '../session'
import { handleRequest, handleResponse, handleResponseException } from './main.js'
// import { TENANT } from '@/common/constant.js'

// 创建一个AXIOS实例
const service = axios.create(
  {
    baseURL: process.env.API,
    timeout: 180000 ,// 请求超时（单位：毫秒）,
    headers:{
      'Cache-Control':"no-store",
      "content-type":"application/json",
      "Pragma":"no-cache"
    }
  })

// Request Interceptor
service.interceptors.request.use(
  config => {
    // Token
    if (getSession('token')) { config.headers.Authorization = getSession('token') }
    // 租户
    // config.headers.tenant = process.env.NODE_ENV == 'development' ? TENANT : 'tenant'
    // 产品
    if (getSession('productInfo') && 'productCode' in getSession('productInfo')) { config.headers.product = getSession('productInfo').productCode }
    // 组织角色
    if (getSession('orgRoleInfo') && 'orgRoleId' in getSession('orgRoleInfo')) { config.headers.orgRoleId = getSession('orgRoleInfo').orgRoleId }
    // 请求处理
    cache: false
    if(config.url != "order/submit"){
      handleRequest(config.headers)
    }
    // console.log(config.headers)
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// Response Interceptor
service.interceptors.response.use(
  response => {
    // 应答处理
    handleResponse(response.config.headers, response)
    // 返回处理
    if (response.data.success === false) { return Promise.reject(response.data) } else { return response }
  },
  error => {
    // 应答异常处理
    if (error.response) { handleResponseException(error.response.config.headers, error.response) }
    // 响应超时处理
    else {
      const response =
      {
        status: '响应超时',
        statusText: '请求已经发送，但接收应答响应超时'
      }
      handleResponseException(error.config.headers, response)
    }
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request/index.js